import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { UncontrolledTooltip } from "reactstrap";
import { ReportSectionHeader } from "../SectionHeader";


const OfferingExposureComponent = (props) => (

	<div>
		<ReportSectionHeader>
			<div id={"classPeriodTradingStatTitle"} className={"SectionHeaderInner"}>
				{"Aggregate Section 11 Exposure Related to Public Offerings"}
			</div>
			<UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
				target={"classPeriodTradingStatTitle"}>
				{""}
				
			</UncontrolledTooltip>
		</ReportSectionHeader>
		<ReportTable
			settings={[
				{
					header: 'Offering Date',
					accessor: 'date',
				},
				{
					header: 'Shares Issued~(000s)', 
					accessor: 'offeringShares',
					formatNumberWithCommas: true,
					inThousands: true,
					centerRightJustified: true,
					dollarValue: false,
					round2whole: true
				},
				{
					header: 'Offering Price', 
					accessor: 'offeringPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: `Complaint Date Price Original SCA Complaint Date: ${props.filingDate}`, 
					accessor: 'complaintPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Price Decline Since Offering', 
					accessor: 'priceDecline',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Exposure\n(000s)', 
					accessor: 'exposure',
					inThousands: true,
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true
				}
			]}
			data={props.offeringExposures}
			name={"offeringExposure"}
			accumulator={"exposure"}
            accumulatorDisplay={"Aggregate Section 11 Exposure" }
		/>
	</div>
);


export default OfferingExposureComponent;


// WEBPACK FOOTER //
// ./src/common/components/OfferingExposure/OfferingExposureComponent.js